import { enumC } from '@mxt/zio/codec'

export enum LasStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}
export const LasStatusC = enumC(LasStatus)
